import { dataHierarchySolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconHierarchySolid = /*#__PURE__*/createIcon(dataHierarchySolid)
export default IconHierarchySolid
